<div class="modal-header">
  <h3>Site Details</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <form class="row" [formGroup]="siteForm">
    <div class="col-12">
      <div class="row g-3">
        <div class="col-4">
          <label for="siteKey" class="form-label" requiredAsterisk
            >Site Key</label
          >
          <input
            type="text"
            class="form-control"
            id="siteKey"
            formControlName="siteKey"
          />
        </div>
        <div class="col-4">
          <label for="legalName" class="form-label" requiredAsterisk
            >Legal Name</label
          >
          <input
            type="text"
            class="form-control"
            id="legalName"
            formControlName="legalName"
          />
        </div>
        <div class="col-4">
          <label for="dba" class="form-label">DBA</label>
          <input
            type="text"
            class="form-control"
            id="dba"
            formControlName="dba"
          />
        </div>
        <div class="col-4">
          <label for="ein" class="form-label" requiredAsterisk
            >EIN(Tax ID #)</label
          >
          <input
            type="text"
            class="form-control"
            id="ein"
            placeholder="__-_______"
            [inputMask]="einMask"
            formControlName="ein"
          />
        </div>
        <div class="col-4">
          <label for="phone" class="form-label" requiredAsterisk>Phone</label>
          <input
            type="text"
            class="form-control"
            id="phone"
            placeholder="(___)___-____"
            [inputMask]="phoneMask"
            formControlName="phone"
          />
        </div>
        <div class="col-2">
          <label for="ext" class="form-label">Ext</label>
          <input
            type="text"
            class="form-control"
            id="ext"
            formControlName="phoneExt"
          />
        </div>
        <div class="col-4">
          <label for="fax" class="form-label">Fax</label>
          <input
            type="text"
            class="form-control"
            id="fax"
            formControlName="fax"
          />
        </div>
        <div class="col-4">
          <label for="units" class="form-label"># of Units</label>
          <input
            type="text"
            class="form-control"
            id="units"
            formControlName="units"
          />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="">
        <h3>Street Address</h3>
        <hr />
        <app-address-form
          [addressForm]="siteForm.controls.StreetAddress"
          [isStreet]="true"
        ></app-address-form>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="col-2 h-100">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>
  <div class="col-2 h-100">
    <button type="button" class="btn btn-primary h-100" (click)="save()">
      Save
    </button>
  </div>
</div>
